export default __webpack_public_path__ + "static/media/header-onboarding-4.1c70fc6e.svg";